/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CentreNotificationsGridDto } from './CentreNotificationsGridDto';
import {
    CentreNotificationsGridDtoFromJSON,
    CentreNotificationsGridDtoFromJSONTyped,
    CentreNotificationsGridDtoToJSON,
} from './CentreNotificationsGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface CentreNotificationsGridDtoPaginatedResults
 */
export interface CentreNotificationsGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof CentreNotificationsGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<CentreNotificationsGridDto>}
     * @memberof CentreNotificationsGridDtoPaginatedResults
     */
    results?: Array<CentreNotificationsGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof CentreNotificationsGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the CentreNotificationsGridDtoPaginatedResults interface.
 */
export function instanceOfCentreNotificationsGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CentreNotificationsGridDtoPaginatedResultsFromJSON(json: any): CentreNotificationsGridDtoPaginatedResults {
    return CentreNotificationsGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function CentreNotificationsGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CentreNotificationsGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(CentreNotificationsGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function CentreNotificationsGridDtoPaginatedResultsToJSON(value?: CentreNotificationsGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(CentreNotificationsGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

